import React from "react";
import { Link } from "react-router-dom";

const PendingApproval = () => {
  return (
    <div className="tw-flex tw-flex-col ">
      <div className="tw-flex tw-flex-col tw-h-screen tw-items-center tw-w-full tw-justify-center">
        <div className="tw-text-center tw-max-w-md">
          <h1 className="tw-text-xl md:tw-text-3xl h-sm:tw-text-2xl tw-font-bold tw-mb-4">
            We've Received Your Application!
          </h1>
          <p className="tw-text-gray-600 tw-text-sm md:tw-text-base tw-mb-6">
            Thank you for applying! Your request is under review, and the
            approval process may take 24 hours or more. We will notify you once
            it is completed.
          </p>

          <div className="tw-mt-10">
            {/* <div className="tw-text-center tw-text-xs md:tw-text-sm">
              Already a registered applicator?{" "}
              <Link to="/signup">
                <span className="tw-text-[#00B5ED] tw-font-medium">
                  Sign up
                </span>
              </Link>
            </div> */}
            <div className="tw-text-center tw-text-xs md:tw-text-sm tw-mb-6 tw-mt-2">
              Back to{" "}
              <Link to="/">
                <span className="tw-text-[#00B5ED] tw-font-medium">Home</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingApproval;
